export default __webpack_public_path__ + "static/media/jd.2cd5fc06.png";